let header = jQuery('.header')

jQuery('.body__before').on('click', function(e) {

    jQuery('.header .hamburger').trigger('click')

})

jQuery('.hamburger').on('click', function (e) {

    e.preventDefault()

    if (jQuery(this).hasClass('is-active')) {
        jQuery('.drawer').attr('tabindex', '-1')
    } else {
        jQuery('.drawer').attr('tabindex', '1').focus()
        // jQuery('.drawer__search button').focus()
    }

    jQuery('body').toggleClass('is-drawer')
    jQuery('.hamburger').toggleClass('is-active')

})

jQuery('.drawer__nav .menu-item-has-children').on('click', function (e) {
    e.preventDefault()

    let thisEl = jQuery(this).children(':first')

    if (thisEl.hasClass('open')) {
        thisEl.toggleClass('open').next().slideToggle()

        jQuery(this).toggleClass( 'open' )
    } else {
        thisEl.toggleClass('open', false).next().slideToggle()
        thisEl.addClass( 'open' )

        jQuery(this).toggleClass('open', false)
        jQuery(this).addClass( 'open' )
    }
})

jQuery('.drawer__nav .menu-item-has-children ul').on('click', function(e) {
    e.stopPropagation()
})

let firstParent = jQuery( '.drawer__nav .current-menu-parent, .drawer__nav .current-menu-ancestor' )

if( firstParent ) {
    firstParent.addClass( 'open' )
    firstParent.find('a:first').addClass('open')

    let firstChild = firstParent.find( 'ul.sub-menu' ).first()
        firstChild.show()

    let secondParent = firstParent.find( '.current-menu-parent' )

    if( secondParent ){
        secondParent.addClass( 'open' )


        let secondChild = secondParent.find( 'ul.sub-menu' ).first()
            secondChild.show();
    }

}
